var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviousordericon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4 0H2.6C1.17 0 0 1.17 0 2.6V18.2C0 19.63 1.17 20.8 2.6 20.8H7.8V24.7C7.8 25.48 8.32 26 9.1 26H9.75C10.01 26 10.4 25.87 10.66 25.61L15.47 20.8H23.4C24.83 20.8 26 19.63 26 18.2V2.6C26 1.17 24.83 0 23.4 0ZM18.2 11.7H12.35L14.69 14.04L13 15.6L7.8 10.4L13 5.2L14.56 6.76L12.35 9.1H18.2V11.7Z",
    fill: "#28AF4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousordericon);
export default __webpack_public_path__ + "static/media/previousordericon.748d7827a9453409202e1ea0e0286d8f.svg";
export { ForwardRef as ReactComponent };